// react
import React, { useState, useEffect } from 'react';

// bootstrap
import Button from 'react-bootstrap/Button';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { setShoppingCart, selectShoppingCart } from '_redux/slices/marketplace/user-marketplace';

// styles
import { Colors, Spacing } from '_styles';

// icons
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

const AddToCartButton = ({ product, onClose, price, quantity, comment }) => {

  // redux
  const dispatch = useDispatch();
  const shoppingCart = useSelector(selectShoppingCart) || {};

  // update cart in redux
  const updateCart = () => {

    const updatedCart = { ...shoppingCart };
    const existingItem = updatedCart[product?.id] || {};

    // Only update if there's a quantity and a comment
    if (quantity > 0 || comment) {
      updatedCart[product.id] = {
        ...product,
        ...existingItem,
        quantity: quantity,
        comment: comment || existingItem.comment || '',
      };
    }

    dispatch(setShoppingCart(updatedCart));

    // close 
    onClose();
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.clickerContainer}>

        {/* add button */}
        <Button
          onClick={updateCart}
          style={styles.circleButton}>

          <div style={{}}>
            <p style={styles.text}>
              Add {quantity} to Cart
            </p>
          </div>

          <div style={styles.circle} />

          <div style={{}}>
            <p style={styles.text}>
              {price ? `€ ${(price * quantity).toFixed(2)}` : ''}
            </p>
          </div>

        </Button>

      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    //borderWidth:1, borderStyle:'solid'
  },
  circle: {
    marginLeft: Spacing.SCALE_4, marginRight: Spacing.SCALE_4,
    height: Spacing.SCALE_6, width: Spacing.SCALE_6, borderRadius: 50, backgroundColor: 'white', alignSelf: 'center', alignItems: 'center', justifyContent: 'center',
  },
  addButtonOnly: {
    width: Spacing.SCALE_32,
    height: Spacing.SCALE_32,
    borderRadius: 16,
    backgroundColor: Colors.PRM_LIGHT_BLUE,
    color: '#fff',
    fontSize: 20,
    fontWeight: 'bold',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
    textAlign: 'center',
  },
  clickerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    //borderWidth:1, borderStyle:'solid'
  },
  quantityContainer: {
    //borderWidth:1, borderStyle:"solid",
    display: 'flex',
    justifyContent: 'center',
    alignSelf: 'center',
    alignItems: 'center',
    marginTop: Spacing.SCALE_10
  },
  circleButton: {
    cursor: 'pointer',
    display: 'flex', justifyContent: 'space-between', flex: 1,
    padding: Spacing.SCALE_12,
  },
  quantity: {
    fontSize: 22,
    fontWeight: 600,
    minWidth: Spacing.SCALE_20,
    textAlign: 'center',
    color: Colors.PRM_LIGHT_BLUE
  },
  text: {
    fontSize: 20,
    fontWeight: '500',
    margin: 0,
  }
};

export default AddToCartButton;
